var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section",attrs:{"id":"start"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6-fullhd"},[_c('projects')],1),_c('div',{staticClass:"column is-3"},[_c('add')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }